// extracted by mini-css-extract-plugin
export default {"progress-bar":"e82421","progress-bar__fill":"fbbe8b","notification-progress":"d007f6"};